import React, { useEffect } from "react";

import GreyTable from '../../../../components/Tables/GreyTable';
import { BalDetail, resetBalDetail } from '../../../../Redux/Slice/Grey/PartyProfile/PartyProfileSlice';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from "js-cookie";
import { Loader } from '../../../../components/Loader/Loader';
import { useTheme } from '../../../../Themecontext/Themecontext';

export const BalanceDetail = ({ selectedProduction, selectedAccount }) => {

  const { Colourdata } = useSelector((state) => state.ClientLogin);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "GRAYDARKNEW",
  );
  const { theme } = useTheme();
  const isdark = theme;


  const formatIndianRupee = (amount) =>
    new Intl.NumberFormat("en-IN", {
      currency: "INR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount ?? 0);

  const formatIndianRupee1 = (amount) =>
    new Intl.NumberFormat("en-IN", {
      currency: "INR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount ?? 0);

  const dispatch = useDispatch();

  const { BalDetailData } = useSelector((state) => state.PartyProfileSlice);

  useEffect(() => {
    dispatch(resetBalDetail())
    dispatch(BalDetail({
      selectedIds: selectedProduction ? selectedProduction.toString() : "",
      PARTYWISEIds: selectedAccount ? selectedAccount.toString() : ""
    }));
  }, [selectedProduction, selectedAccount]);

  const columns = [
    { key: "srNumber", label: "Sr. No.", align: "center", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { key: "MonthName", label: "Month", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { key: "InwardDate", label: "InwardDate", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "ChallanNo", label: "Challan No", align: "right", rupees: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "ShortAcName", label: "Party Marka", align: "right", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { key: "LotNo", label: "Lot. No.", align: "right", rupees: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "Itemname", label: "Quality Name", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "Taka", label: "Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "BalanceTaka", label: "Balance Taka", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "BalanceMeter", label: "Balance Meter", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
  ];

  const row = BalDetailData?.BalDate?.map((row, index, arr) => {
    const totalLength = arr.length.toString().length;
    return {
      id: index,
      // srNumber: (index + 1).toString().padStart(totalLength, "0"),
      ...row,
      InwardDate: new Date(row.InwardDate).toLocaleDateString("en-GB"),
      LotNo: row.LotNo,
      Taka: row.Taka,
      BalanceTaka: row.BalanceTaka,
      BalanceMeter: row.BalanceMeter,
    };
  })

  if (BalDetailData === null) {

    return (
      <div className="flex justify-center items-center h-screen text-xl text-green-700">
        <Loader />
      </div>
    );
  }


  return (
    <div>
      <Row>
        <Col>
          <div
            style={{
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
            }}
          >
            <div
              style={{
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour1,
                color:
                  isdark === "light"
                    ? iscolour?.Colour5
                    : iscolourDark?.Colour8,
                padding: "14px",
              }}
            >
              <h2 style={{ fontSize: "18px", margin: 0, letterSpacing: "1px" ,fontWeight:"700" }}>
                BALANCE DETAIL
              </h2>
            </div>
            <div><GreyTable columns={columns} data={row} iscolourDark={iscolourDark}
              iscolour={iscolour} /></div>
          </div>
        </Col>
      </Row>
    </div>
  )
}

